import { render, staticRenderFns } from "./DetallePokemon.vue?vue&type=template&id=2571585e&"
import script from "./DetallePokemon.vue?vue&type=script&lang=js&"
export * from "./DetallePokemon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports